import React, { useState, useEffect, useMemo } from "react";
import "../../../css/CRUDModal.css";
import ButtonTriangle from "../../../assets/Icons/Button Triangle.png";
import FilterIcon from "../../../assets/Icons/Orange Filter.png";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";
import Dropdown from "../../../components/Dropdown";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import { axiosGetApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";

const statusOptions = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "In-Active" },
];

const DeliveryFilterModal = ({
  show,
  handleClose,
  pageSize,
  currentPage,
  filterData,
  setFilterData,
  handleReset,
  deliveryList = [],
  fetchDeliveryBoyData,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      fullName: filterData.fullName || "",
      mobileNo: filterData.mobileNo || "",
      status: filterData.status || [],
    },
    mode: "onChange",
  });

  const watchedValues = watch();

  useEffect(() => {
    if (show) {
      reset({
        fullName: filterData?.fullName || "",
        mobileNo: filterData?.mobileNo || "",
        status: filterData?.status || [],
      });
    }
  }, [show, filterData, reset]);

  const [selectedTab, setSelectedTab] = useState("Full Name");
  const [loading, setLoading] = useState(false);
  const [allDeliveryBoys, setAllDeliveryBoys] = useState([]);
  const loggedInUserName = sessionStorage.getItem("username");

  useEffect(() => {
    fetchAllDeliveryBoys();
  }, []);

  const fetchAllDeliveryBoys = async () => {
    try {
      const response = await axiosGetApi(
        `${apiList.FETCH_ALL_DELIVERY_BOY_DATA}?username=${loggedInUserName}`
      );
      if (
        response?.status === 200 &&
        response?.data?.status === true &&
        Array.isArray(response?.data?.data)
      ) {
        setAllDeliveryBoys(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching all delivery boys:", error);
    }
  };

  const combinedNames = useMemo(() => {
    const namesSet = new Set();

    if (Array.isArray(allDeliveryBoys)) {
      allDeliveryBoys.forEach((boy) => {
        const name = boy?.fullName;
        if (name && typeof name === "string" && name.trim()) {
          namesSet.add(name.trim());
        }
      });
    }

    if (Array.isArray(deliveryList)) {
      deliveryList.forEach((boy) => {
        const name = boy?.fullName;
        if (name && typeof name === "string" && name.trim()) {
          namesSet.add(name.trim());
        }
      });
    }

    const list = Array.from(namesSet);
    list.sort((a, b) =>
      a.localeCompare(b, undefined, { sensitivity: "base" })
    );
    return list;
  }, [allDeliveryBoys, deliveryList]);

  const currentFullName =
    watchedValues?.fullName || filterData?.fullName || "";

  const nameDropdownOptions = useMemo(() => {
    const list = combinedNames.map((name) => ({
      label: name,
      value: name,
      fullName: name,
    }));

    if (currentFullName) {
      return [
        { label: "✕ Clear Name Selection", value: "", fullName: "" },
        ...list,
      ];
    }
    return list;
  }, [combinedNames, currentFullName]);

  const hasActiveFilter = (tabName) => {
    switch (tabName) {
      case "Full Name":
        return Boolean(filterData?.fullName && filterData.fullName.trim() !== "");
      case "Contact Number":
        return Boolean(filterData?.mobileNo && filterData.mobileNo.trim() !== "");
      case "Status":
        return Boolean(filterData?.status && filterData.status.length > 0);
      default:
        return false;
    }
  };

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const onSubmit = (formData) => {
    setFilterData(formData);
    if (fetchDeliveryBoyData) {
      fetchDeliveryBoyData(1, formData, pageSize);
    }
    handleClose();
  };

  const onReset = () => {
    const emptyFilters = {
      fullName: "",
      mobileNo: "",
      status: [],
    };
    reset(emptyFilters);
    setFilterData(emptyFilters);
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title">Filter</h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="close icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {["Full Name", "Contact Number", "Status"].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                            style={
                              hasActiveFilter(tab) && selectedTab !== tab
                                ? {
                                    outline: "2px solid #FF6B35",
                                    outlineOffset: "2px",
                                  }
                                : {}
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content !bg-[linear-gradient(to_bottom,#FFE8D4_0%_100%,transparent_25%_100%)]">
                      {selectedTab === "Full Name" && (
                        <Controller
                          name="fullName"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Full Name</label>
                              <div className="dateInputWrapper">
                                <Dropdown
                                  placeholder="Select Full Name"
                                  options={nameDropdownOptions}
                                  value={
                                    field.value ||
                                    watchedValues?.fullName ||
                                    filterData?.fullName ||
                                    ""
                                  }
                                  labelKey="label"
                                  valueKey="value"
                                  showSearch={true}
                                  selectClassName="!h-[38px] !rounded-[6px]"
                                  onChange={(item) => {
                                    const selectedName =
                                      item && item.value ? item.value : "";
                                    field.onChange(selectedName);
                                    setValue("fullName", selectedName);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      fullName: selectedName,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Contact Number" && (
                        <Controller
                          name="mobileNo"
                          control={control}
                          render={({ field }) => (
                            <div className="dateField">
                              <label className="dateLabel">Contact Number</label>
                              <div className="dateInputWrapper">
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Enter Contact Number"
                                  className="dateInput"
                                  maxLength={10}
                                  value={watchedValues.mobileNo || ""}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(
                                      /[^0-9]/g,
                                      ""
                                    );
                                    field.onChange(val);
                                    setValue("mobileNo", val);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      mobileNo: val,
                                    }));
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        />
                      )}

                      {selectedTab === "Status" && (
                        <div className="dateField">
                          <label
                            className="dateLabel"
                            style={{
                              marginBottom: "0.5rem",
                              fontWeight: "600",
                              fontSize: "20px",
                            }}
                          >
                            Status
                          </label>
                          <div
                            className="dateInputWrapper"
                            style={{
                              display: "flex",
                              gap: "1rem",
                              flexWrap: "wrap",
                              padding: "0.75rem",
                              backgroundColor: "#ffdab8",
                              border: "1px solid #ced4da",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {statusOptions.map((status) => (
                              <label
                                key={status.value}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={(
                                    filterData.status || []
                                  ).includes(status.value)}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const newStatus = isChecked
                                      ? [
                                          ...(filterData.status || []),
                                          status.value,
                                        ]
                                      : (filterData.status || []).filter(
                                          (v) => v !== status.value
                                        );
                                    setValue("status", newStatus);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: newStatus,
                                    }));
                                  }}
                                />
                                {status.label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back w-[133px] !rounded-lg"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit w-[133px] !rounded-lg"
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Apply"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DeliveryFilterModal;
